module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('demo-error-modal'), _vm._v(" "), _c('demo-login-modal'), _vm._v(" "), _c('demo-dog-profile-modal'), _vm._v(" "), _c('demo-conditional-modal'), _vm._v(" "), _c('demo-focus-modal'), _vm._v(" "), _c('demo-size-modal'), _vm._v(" "), _c('modals-container'), _vm._v(" "), _c('v-dialog', {
    on: {
      "before-opened": function($event) {
        _vm.dialogEvent('before-open')
      },
      "before-closed": function($event) {
        _vm.dialogEvent('before-close')
      },
      "opened": function($event) {
        _vm.dialogEvent('opened')
      },
      "closed": function($event) {
        _vm.dialogEvent('closed')
      }
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "example-modal",
      "transition": "nice-modal-fade",
      "min-width": 200,
      "min-height": 200,
      "delay": 100,
      "adaptive": _vm.adaptive,
      "resizable": _vm.resizable,
      "draggable": _vm.draggable
    }
  }, [_c('div', {
    staticClass: "example-modal-content"
  }, [_vm._v("\n      Appropriately exploit professional infrastructures rather than unique growth strategies. Assertively build leveraged growth strategies vis-a-vis multimedia based vortals. Progressively simplify cross-platform value through interactive imperatives. Objectively\n      implement enabled web services after plug-and-play ROI. Distinctively impact inexpensive schemas before installed base imperatives. Holisticly benchmark pandemic process improvements without wireless experiences. Efficiently create worldwide partnerships\n      after tactical vortals. Uniquely productize enabled platforms vis-a-vis timely processes. Conveniently unleash standards compliant niches through highly efficient testing procedures. Rapidiously enable pandemic niche markets whereas viral markets.\n      Assertively simplify alternative partnerships and error-free e-commerce. Professionally formulate 24/365 internal or \"organic\" sources through equity invested mindshare. Globally redefine unique best practices for.\n\n      "), _c('input', {
    attrs: {
      "placeholder": "Email"
    }
  })])]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('pre', {
    staticStyle: {
      "line-height": "1.5"
    }
  }, [_vm._v("    npm install --save vue-js-modal\n\n    ...\n    import vmodal from 'vue-js-modal'\n    Vue.use(vmodal)\n  ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "15px"
    }
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.show(false, false, false)
      }
    }
  }, [_vm._v("Simple")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.show(true, false, false)
      }
    }
  }, [_vm._v("Resizable")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.show(false, true, false)
      }
    }
  }, [_vm._v("Adaptive")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.show(false, false, true)
      }
    }
  }, [_vm._v("Draggable")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.$modal.show('dog-profile')
      }
    }
  }, [_vm._v("\n      Demo: Dog Profile photo\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.$modal.show('error-modal')
      }
    }
  }, [_vm._v("\n      Demo: Error handling\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.$modal.show('demo-login')
      }
    }
  }, [_vm._v("\n      Demo: Login\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.$modal.show('size-modal')
      }
    }
  }, [_vm._v("\n      Demo: Width: 60%, Height: auto\n    ")]), _vm._v(" "), _c('button', {
    class: _vm.canBeShown ? 'btn green' : 'btn red',
    on: {
      "click": _vm.conditionalShow
    }
  }, [_vm._v("\n      Can "), (!_vm.canBeShown) ? _c('b', [_vm._v("NOT")]) : _vm._e(), _vm._v(" be shown\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.showBasicDialog
    }
  }, [_vm._v("\n      Dialog: basic\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.showTitleDialog
    }
  }, [_vm._v("\n      Dialog: title\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.showButtonsDialog
    }
  }, [_vm._v("\n      Dialog: buttons\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.showDynamicRuntimeModal
    }
  }, [_vm._v("\n      Dynamic: Runtime Modal\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.showDynamicComponentModal
    }
  }, [_vm._v("\n      Dynamic: Component Modal\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.showDynamicComponentModalWithModalParams
    }
  }, [_vm._v("\n      Dynamic: Component Modal with modal params\n    ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Vue.js Modal\n    "), _c('a', {
    attrs: {
      "href": "https://github.com/euvl/vue-js-modal/blob/master/README.md",
      "target": "readme"
    }
  }, [_vm._v("Readme")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/euvl/vue-js-modal/issues",
      "target": "issues"
    }
  }, [_vm._v("Issues")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/euvl/vue-js-modal/tree/master/demo/client_side_rendering/src/components/modals",
      "target": "issues"
    }
  }, [_vm._v("Examples")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d897227e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 38
// module chunks = 0